// @ts-check
import React from "react"
import Button from "../atoms/Button.atom"
import Tooltip from "../atoms/Tooltip.atom"
import { useNavigate } from "react-router-dom"
import {
  DEFAULT_INDIVIDUAL_CLIENT_REPORT_FILTER_CONFIG,
  DEFAULT_INDIVIDUAL_CLIENT_REPORT_SORT_CONFIG,
} from "../../consts/reports.consts"
import { resolveDateRangeFromShortcutState } from "../../utils/report.utils"
import { useExportTasksPerClient } from "../../hooks/reports/useExportTasksPerClient"
import { useSession } from "../../hooks/auth/useSession.hook"
import useThemeContext from "../../hooks/contextConsumers/useThemeContext.hook"
import { THEME_MODES } from "../../consts/themes.consts"

/**
 * @param {import("./ShortcutItem.molecule.types").ShortcutItemProps} props
 */
export function ShortcutItem(props) {
  const { user } = useSession()
  const id = `shortcut-item-${props.title.replace(/\s+/g, "-").toLowerCase()}`
  const navigate = useNavigate()
  const { theme } = useThemeContext()
  const isDarkTheme = theme === THEME_MODES.DARK

  const { exportTasks, loading } = useExportTasksPerClient()

  const handleDownload = async () => {
    if (props.isLink) {
      window.open(props.to, "_blank")
      return
    }
    const dateRange = resolveDateRangeFromShortcutState(props.state)

    if (!dateRange) {
      return
    }

    const [startDate, endDate] = dateRange

    await exportTasks({
      clientCode: props.clientCode,
      filterConfig: DEFAULT_INDIVIDUAL_CLIENT_REPORT_FILTER_CONFIG,
      sortConfig: DEFAULT_INDIVIDUAL_CLIENT_REPORT_SORT_CONFIG,
      startDate,
      endDate,
      period: props.state.period,
      isLink: props.isLink || false,
    })
  }

  return (
    <>
      <Tooltip
        target={`#${id} .shortcut-item__content`}
        content={
          props.isLink ?
            "Click para abrir el enlace"
          : "Click para ir al reporte"
        }
        position="right"
      />
      <div className="shortcut-item" id={id}>
        <div
          className="shortcut-item__content"
          onClick={() => {
            if (props.isLink) {
              window.open(window.location.origin + props.to, "_blank")
            } else {
              navigate(props.to, {
                state: { ...props.state, clientCode: props.clientCode },
              })
            }
          }}
        >
          <p
            className={`shortcut-item__title p-text-secondary ${isDarkTheme ? "shortcut-item__title--dark" : ""}`}
          >
            {props.title}
          </p>
          <p
            className={`shortcut-item__description p-text-secondary ${isDarkTheme ? "shortcut-item__description--dark" : ""}`}
          >
            {props.description}
          </p>
        </div>
        <Button
          icon={props.isLink ? "pi pi-external-link" : "pi pi-download"}
          className="p-button-rounded p-button-secondary shortcut-item__button"
          onClick={handleDownload}
          loading={loading}
        />
      </div>
    </>
  )
}
